import { useDrop } from 'react-dnd';
import ControlKind from '../Shared/controlKind';
import ControlState from '../Shared/controlState';
import { PreviewCard, DragTypes } from './';
import type { DraggableItem } from './';
import Stack from '@mui/material/Stack';
import ControlEngine from '../ControlEngine/ControlEngine';

interface PageCardProps {
  pageId: string;
  createNewCard: (type: ControlKind, page: string, index: number) => void;
  control: ControlState;
}

export default ({ pageId, createNewCard, control }: PageCardProps) => {
  const [{ isActive, itemDragged }, drop] = useDrop(
    () => ({
      accept: DragTypes.PALETTE_CONTROL,
      drop(item: DraggableItem) {
        if (item.type) {
          createNewCard(item.type, pageId, 1);
        }
      },
      collect: (monitor) => ({
        isActive: monitor.canDrop() && monitor.isOver(),
        itemDragged: monitor.getItem()
      })
    }),
    [createNewCard, pageId]
  );

  return (
    <div ref={drop}>
      <Stack>
        <ControlEngine control={control} />
      </Stack>

      {isActive && PreviewCard(itemDragged.type)}
    </div>
  );
};
